module.exports = __webpack_public_path__ + "img/hr-rail-signal.7e6caa63.png";